import styled from 'styled-components';
import PropTypes from 'prop-types';

const Styled = styled.div`
  display: flex;
  box-sizing: border-box;
  min-width: 0;
  background-color: ${({ backgroundColor, theme }) =>
    theme.colors[backgroundColor] || undefined};
  border-width: ${({ borderWidth }) => `${borderWidth || 0}px`};
  border-style: solid;
  border-color: ${({ borderColor, theme }) =>
    theme.colors[borderColor] || theme.colors.cardBorderColor};
  border-radius: ${({ borderRadius }) => `${borderRadius || 0}px`};
`;

const Box = ({ children, onClick, ...other }) => {
  return (
    <Styled onClick={onClick} {...other}>
      {children}
    </Styled>
  );
};

Box.defaultProps = {
  children: undefined,
  other: undefined,
};

Box.propTypes = {
  children: PropTypes.node,
  other: PropTypes.any,
};

export default Box;
